export const WINDOW_RESIZE = "WINDOW_RESIZE";
export const REDIRECT = "REDIRECT";
export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const SIGNIN = "SIGNIN";
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNIN_ERROR = "SIGNIN_ERROR";
export const SIGNOUT = "SIGNOUT";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_ALL_USERS_SUCCESS = "GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_ERROR = "GET_ALL_USERS_ERROR";
export const REQ_PWD_CHANGE = "REQ_PWD_CHANGE";
export const CHANGE_PWD = "CHANGE_PWD";
export const CHANGE_PWD_SUCCESS = "CHANGE_PWD_SUCCESS";
export const CHANGE_PWD_ERROR = "CHANGE_PWD_ERROR";

export const windowResizeAction = () => ({
  type: WINDOW_RESIZE,
});

export const redirectAction = (payload) => ({
  type: REDIRECT,
  payload,
});

export const openModalAction = (payload) => ({
  type: OPEN_MODAL,
  payload,
});

export const closeModalAction = () => ({
  type: CLOSE_MODAL,
});

export const signInAction = (payload) => ({
  type: SIGNIN,
  payload,
});

export const signInSuccessAction = (payload) => ({
  type: SIGNIN_SUCCESS,
  payload,
});

export const signInErrorAction = (payload) => ({
  type: SIGNIN_ERROR,
  payload,
});

export const passwordRequiredChangeAction = (payload) => ({
  type: REQ_PWD_CHANGE,
  payload,
});

export const changePasswordAction = (payload) => ({
  type: CHANGE_PWD,
  payload,
});

export const changePasswordSuccessAction = (payload) => ({
  type: CHANGE_PWD_SUCCESS,
  payload,
});

export const changePasswordErrorAction = (payload) => ({
  type: CHANGE_PWD_ERROR,
  payload,
});

export const signOutAction = () => ({
  type: SIGNOUT,
});

export const refreshTokenAction = (payload) => ({
  type: REFRESH_TOKEN,
  payload,
});
export const refreshTokenSuccessAction = (payload) => ({
  type: REFRESH_TOKEN_SUCCESS,
  payload,
});

export const getAllUsersAction = () => ({
  type: GET_ALL_USERS,
});

export const getAllUsersSuccessAction = (payload) => ({
  type: GET_ALL_USERS_SUCCESS,
  payload,
});

export const getAllUsersErrorAction = () => ({
  type: GET_ALL_USERS_ERROR,
});
